"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var iconFactory_1 = require("../../utils/iconFactory");
// AEM-Name: CaretDownIcon
exports.CaretDownIcon = iconFactory_1.iconFactory({
    componentName: 'CaretDownIcon',
    viewBox: '0 0 32 32',
    title: 'CaretDownIcon',
    g: "<g>\n<path d=\"M28.8 8.672h-25.6l12.8 14.624 12.8-14.624z\"/>\n</g>",
    gThemed: { "ergo-one": { "viewBox": "0 0 32 32", "g": "<g><path d=\"M28.8 8.672h-25.6l12.8 14.624 12.8-14.624z\"/></g>" } }
});
exports.default = exports.CaretDownIcon;
//# sourceMappingURL=CaretDownIcon.js.map